<template>
  <div v-if="!!icon" class="overflow-hidden rounded-full">
    <img class="rounded-full" style="transform: scale(1.1);" :src=icon.path :alt=icon.alt />
  </div>
</template>

<script>
import mastercardSymbol from '../assets/images/app-icons/mastercard.svg'

export default {
  name: 'BrandIconMdn',
  props: {
    brandName: String
  },
  computed: {
    icon () {
      if (!this.brandName) return

      const brands = [
        { name: 'whatsapp', path: 'https://mondrian.claro.com.br/brands/app/72px-default/whatsapp.svg', alt: 'WhatsApp' },
        { name: 'waze', path: 'https://mondrian.claro.com.br/brands/app/72px-default/waze.svg', alt: 'Waze' },
        { name: 'claro_banca', path: 'https://mondrian.claro.com.br/brands/app/72px-default/claro-banca.svg', alt: 'Claro Banca' },
        { name: 'claro_skeelo', path: 'https://mondrian.claro.com.br/brands/app/72px-default/skeelo.svg', alt: 'Claro Skeelo' },
        { name: 'facebook', path: 'https://mondrian.claro.com.br/brands/app/72px-default/facebook.svg', alt: 'Facebook' },
        { name: 'twitter', path: 'https://mondrian.claro.com.br/brands/app/72px-default/twitter.svg', alt: 'Twitter' },
        { name: 'instagram', path: 'https://mondrian.claro.com.br/brands/app/72px-default/instagram.svg', alt: 'Instagram' },
        { name: 'tik_tok', path: 'https://mondrian.claro.com.br/brands/app/72px-default/tik-tok.svg', alt: 'TikTok' },
        { name: 'claro_video', path: 'https://mondrian.claro.com.br/brands/app/72px-default/claro-video.svg', alt: 'Claro Video' },
        { name: 'youtube', path: 'https://mondrian.claro.com.br/brands/app/72px-default/youtube.svg', alt: 'Youtube' },
        { name: 'claro_tv', path: 'https://mondrian.claro.com.br/brands/app/72px-default/claro-tvmais.svg', alt: 'Claro Tv' },
        { name: 'chatgpt', path: 'https://mondrian.claro.com.br/brands/app/72px-default/chatgpt-icon.svg', alt: 'ChatGPT' },

        { name: 'amex', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/american-express.svg', alt: 'Amex' },
        { name: 'visa', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/visa.svg', alt: 'Visa' },
        { name: 'diners', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/diners-club.svg', alt: 'Diners' },
        { name: 'mastercard', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/mastercard.svg', alt: 'Mastercard' },
        { name: 'master', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/mastercard.svg', alt: 'Master' },
        { name: 'hipercard', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/hipercard.svg', alt: 'Hipercard' },
        { name: 'hiper', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/hipercard.svg', alt: 'Hipercard' },
        { name: 'elo', path: 'https://mondrian.claro.com.br/brands/app/32px-alternative/elo.svg', alt: 'Elo' },
        { name: 'mastercard_symbol', path: mastercardSymbol, alt: 'Mastercard' }
      ]
      return brands.find(b => b.name === this.brandName.toLowerCase())
    }
  }
}
</script>
